module.exports = __webpack_public_path__ + "img/Conflict Confronter.ee606027.svg";